import styled from "styled-components"

export interface StyledRatingProps {
  rating?: string
}

export const StyledReviewWrapper = styled.div`
  background: ${(props) => props.theme.colors.white};
  padding: 32px;
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};

  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    padding: 24px;
  }
`

export const StyledReview = styled.div`
  ${(props) => props.theme.mixins.body};
  padding-bottom: 24px;
  border-bottom: 1px solid ${(props) => props.theme.colors.darkGrey10};
`

export const StyledDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;

  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const StyledName = styled.div`
  ${(props) => props.theme.mixins.bold};

  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    padding-bottom: 8px;
  }
`

export const StyledStar = styled.div`
  padding-right: 2px;
`

export const StyledRating = styled.div<StyledRatingProps>`
  display: flex;

  & svg {
    color: ${(props) => props.theme.colors.masters};
    max-width: 16px;
  }

  & div {
    ${(props) =>
      props.rating === "4" &&
      `
      &:nth-of-type(5){
        & svg {
            color: ${props.theme.colors.darkGrey10};
          }
          
        }
    `}
    ${(props) =>
      props.rating === "3" &&
      `
      &:nth-of-type(5), &:nth-of-type(4){
        & svg {
            color: ${props.theme.colors.darkGrey10};
          }
        }
    `}
   ${(props) =>
      props.rating === "2" &&
      `
      &:nth-of-type(5), &:nth-of-type(4), &:nth-of-type(3){
        & svg {
            color: ${props.theme.colors.darkGrey10};
          }
        }
    `}
    ${(props) =>
      props.rating === "1" &&
      `
      &:nth-of-type(5), &:nth-of-type(4), &:nth-of-type(3), &:nth-of-type(2) {
        & svg {
            color: ${props.theme.colors.darkGrey10};
          }
        }
    `}
  }
`
